export default __webpack_public_path__ + "fonts/132f80bfb8f76d3384514437b7572354.svg";